<template>
  <v-card class="mx-auto mt-n3">
    <!-- Banner Section -->
    <v-img :src="`${url}${data.banners[0].web}`" class="my-3" contain />
    <v-card-title class="justify-center text-uppercase page-title">
      {{ data.title }}
    </v-card-title>
    <!-- Banner Section -->

    <!-- Tabs Section-->
    <v-tabs background-color="accent-4" centered class="mytabs" v-model="tab">
      <v-tab
        href="#arrivals"
        class="border-radiusbefore"
        @click="onSelectTab('arrivals')"
      >
        Arrivals
      </v-tab>
      <v-tab-item value="arrivals">
        <v-container>
          <v-card
            class="mx-auto rounded-xl mb-10"
            v-scrollanimation
            :class="{ arrivalDepSearch: $vuetify.breakpoint.lgAndUp }"
          >
            <v-row>
              <v-col cols="12" md="3">
                <v-list-item>
                  <v-list-item-avatar
                    rounded="0"
                    size="15"
                    class="mt-5 ml-2 hidden-sm-and-down"
                    style="margin-top: 4px"
                  >
                    <v-img :src="require('../../assets/images/search.svg')" />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-text-field
                      v-model="search"
                      v-on:keyup="onApplyFilter"
                      solo
                      label="Search by City / Flight no."
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-divider
                class="mt-5 mb-5 hidden-sm-and-down"
                vertical
              ></v-divider>
              <v-col cols="12" md="3" class="hidden-sm-and-down">
                <v-list-item>
                  <v-list-item-avatar rounded="0" size="15" class="mt-5 ml-5">
                    <v-img
                      :src="require('../../assets/images/allflightIcon.svg')"
                    />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <div>
                      <v-select
                        solo
                        v-model="selectedFlightType"
                        @change="onApplyFilter"
                        :items="flightsTypes"
                        hide-details
                        label="All Flights"
                        flat
                      ></v-select>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-divider class="mt-5 mb-5" vertical></v-divider>
              <v-col cols="12" md="3" class="hidden-sm-and-down">
                <v-list-item>
                  <v-list-item-avatar rounded="0" size="15" class="mt-4 ml-5">
                    <v-img
                      :src="require('../../assets/images/allterminalIcon.svg')"
                    />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <div>
                      <v-select
                        solo
                        v-model="selectedTerminal"
                        @change="onApplyFilter"
                        :items="terminals"
                        hide-details
                        label="All Terminals"
                        flat
                      ></v-select>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="1" class="hidden-sm-and-down">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-dialog max-width="600" v-model="filterDialog">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          rounded
                          large
                          color="#E8EFFE"
                          v-bind="attrs"
                          v-on="on"
                          class="ml-0 filterBtn"
                        >
                          <v-img
                            :src="
                              require('../../assets/images/filter-icon.svg')
                            "
                            :class="{
                              fillterIconSmall: $vuetify.breakpoint.smAndDown,
                            }"
                          />
                          Filters
                        </v-btn>
                      </template>
                      <template v-slot:default="filterDialog">
                        <v-card class="rounded-xl">
                          <v-card-title>
                            <span class="text-h5">Sort & Filter</span>
                          </v-card-title>

                          <v-card-text>
                            <v-tabs vertical class="vertical-tab-Two mb-15">
                              <v-tab class=""> Type </v-tab>

                              <v-tab class=""> Terminal </v-tab>

                              <v-tab-item>
                                <v-card flat class="mx-auto" tile>
                                  <v-list>
                                    <v-list-item-group color="primary">
                                      <v-list-item>
                                        <v-list-item-content>
                                          <v-radio-group
                                            column
                                            v-model="selectedFlightType"
                                            @change="onApplyFilter"
                                          >
                                            <v-radio
                                              v-for="(
                                                flightType, i
                                              ) in flightsTypes"
                                              v-bind:label="flightType.text"
                                              v-bind:value="flightType.value"
                                              v-bind:key="i"
                                            ></v-radio>
                                          </v-radio-group>
                                        </v-list-item-content>
                                      </v-list-item>
                                    </v-list-item-group>
                                  </v-list>
                                </v-card>
                              </v-tab-item>

                              <v-tab-item>
                                <v-list-item-content>
                                  <v-radio-group
                                    column
                                    v-model="selectedTerminal"
                                    @change="onApplyFilter"
                                  >
                                    <v-radio
                                      v-for="(terminal, i) in terminals"
                                      v-bind:label="terminal.text"
                                      v-bind:value="terminal.value"
                                      v-bind:key="i"
                                    />
                                  </v-radio-group>
                                </v-list-item-content>
                              </v-tab-item>
                            </v-tabs>
                          </v-card-text>
                          <v-card-actions class="justify-end">
                            <v-btn text @click="onResetFilter()">
                              Reset Filters >
                            </v-btn>
                            <!-- <v-btn
                              rounded
                              dark
                              large
                              class="gradient-button pl-10 pr-10"
                              @click="onApplyFilter()"
                            >
                              Apply
                            </v-btn> -->
                          </v-card-actions>
                        </v-card>
                      </template>
                    </v-dialog>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="2" class="hidden-sm-and-down">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-btn
                      rounded
                      dark
                      large
                      class="gradient-button"
                      @click="onResetFilter"
                    >
                      See All Flights
                    </v-btn>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-card>
          <v-row class="mb-10">
            <v-col>
              <v-card flat>
                <v-card-actions>
                  <span> Last updated: {{ current.fullDate }} IST </span>
                  <v-spacer></v-spacer>
                  <v-btn
                    depressed
                    rounded
                    dark
                    large
                    :disabled="isRefreshing"
                    class="gradient-button pl-10 pr-10"
                    @click="onRefresh()"
                  >
                    <v-icon left>mdi-refresh</v-icon>
                    Refresh
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-data-table
            :page.sync="pagination.page"
            :items-per-page="pagination.limit"
            :loading="loader"
            @click:row="onRowClick"
            :headers="arrivalHeader"
            :items="flights"
            class="mytable hidden-sm-and-down"
            hide-default-header
          >
            <template v-slot:header="{ props: { headers } }">
              <thead class="">
                <tr>
                  <th v-for="h in headers" :class="h.class">
                    <span>{{ h.text }}</span>
                  </th>
                </tr>
              </thead>
            </template>
            <template v-slot:[`item.airlineName`]="{ item }"
              ><span class="small-text-table" style="display: block">{{
                item.airlineName
              }}</span>
              <span>{{ item.flightName }}</span></template
            >
            <template v-slot:[`item.img`]="{ item }">
              <v-card flat color="transparent" class="pt-6 pb-6">
                <v-card-title class="pa-0 ml-6">
                  <v-avatar
                    tile
                    :size="$vuetify.breakpoint.smAndDown ? '40' : '56'"
                  >
                    <img :src="item.img" class="mt-1" />
                  </v-avatar>
                </v-card-title>
              </v-card>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <v-alert
                class="rounded-xl text-center status-alert"
                text
                :color="renderStatus(item.status)"
              >
                {{ item.status }}
              </v-alert>
            </template>
            <template v-slot:[`item.scheduled`]="{ item }">
              <td class="">
                {{ item.scheduled }}
              </td>
            </template>
            <template v-slot:[`item.terminal`]="{ item }">
              <td class="">
                {{ item.terminal }}
              </td>
            </template>
            <template v-slot:[`item.baggage`]="{ item }">
              <td class="">
                {{ item.baggage }}
              </td>
            </template>
          </v-data-table>

          <v-data-table
            :loading="loader"
            @click:row="onRowClick"
            :headers="arrivalHeader"
            :items="flights"
            class="mobileTable hidden-md-and-up"
            hide-default-header
            hide-default-footer
            disable-pagination
          >
            <template v-slot:item="{ item }">
              <v-card class="mobileCard" @click="onRowClick(item)">
                <v-list>
                  <v-list-item>
                    <v-list-item-avatar
                      :size="$vuetify.breakpoint.smAndDown ? '40' : '56'"
                    >
                      <img :src="item.img" style="height: auto" />
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-subtitle>{{
                        item.airlineName
                      }}</v-list-item-subtitle>
                      <v-list-item-title>{{
                        item.flightName
                      }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-alert
                        class="rounded-xl text-center"
                        text
                        :color="renderStatus(item.status)"
                      >
                        {{ item.status }}
                      </v-alert>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
                <v-list>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle>{{
                        item.originmap
                      }}</v-list-item-subtitle>
                      <v-list-item-title>{{ item.origin }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-avatar size="25">
                      <v-img :src="require('../../assets/images/plain.svg')" />
                    </v-list-item-avatar>
                    <v-list-item-content class="text-end">
                      <v-list-item-subtitle>{{
                        item.destinationmap
                      }}</v-list-item-subtitle>
                      <v-list-item-title>{{
                        item.destination
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-card-actions>
                  <span style="margin-right: 5px"
                    >Scheduled
                    <label style="font-weight: 700">{{ item.scheduled }}</label>
                  </span>
                  |
                  <span style="margin-left: 5px"
                    >Estimated
                    <label style="font-weight: 700">{{
                      item.estimated
                    }}</label></span
                  >
                </v-card-actions>
              </v-card>
            </template>
          </v-data-table>
        </v-container>
      </v-tab-item>
      <v-tab
        href="#departures"
        class="border-radiusafter"
        @click="onSelectTab('departures')"
      >
        Departures
      </v-tab>
      <v-tab-item value="departures">
        <v-container>
          <v-card
            class="mx-auto rounded-xl mb-10"
            v-scrollanimation
            :class="{ arrivalDepSearch: $vuetify.breakpoint.lgAndUp }"
          >
            <v-row>
              <v-col cols="12" md="3">
                <v-list-item>
                  <v-list-item-avatar
                    rounded="0"
                    size="15"
                    class="mt-5 ml-2 hidden-sm-and-down"
                  >
                    <v-img :src="require('../../assets/images/search.svg')" />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-text-field
                      v-model="search"
                      v-on:keyup="onApplyFilter"
                      solo
                      label="Search by City / Flight no."
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-divider
                class="mt-5 mb-5 hidden-sm-and-down"
                vertical
              ></v-divider>
              <v-col cols="12" md="3" class="hidden-sm-and-down">
                <v-list-item>
                  <v-list-item-avatar rounded="0" size="15" class="mt-5 ml-5">
                    <v-img
                      :src="require('../../assets/images/allflightIcon.svg')"
                    />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <div>
                      <v-select
                        solo
                        v-model="selectedFlightType"
                        @change="onApplyFilter"
                        :items="flightsTypes"
                        hide-details
                        label="All Flights"
                        flat
                      ></v-select>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-divider class="mt-5 mb-5" vertical></v-divider>
              <v-col cols="12" md="3" class="hidden-sm-and-down">
                <v-list-item>
                  <v-list-item-avatar rounded="0" size="15" class="mt-4 ml-5">
                    <v-img
                      :src="require('../../assets/images/allterminalIcon.svg')"
                    />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <div>
                      <v-select
                        solo
                        v-model="selectedTerminal"
                        @change="onApplyFilter"
                        :items="terminals"
                        hide-details
                        label="All Terminals"
                        flat
                      ></v-select>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="1" class="hidden-sm-and-down">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-dialog max-width="600" v-model="filterDialog">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          rounded
                          large
                          color="#E8EFFE"
                          v-bind="attrs"
                          v-on="on"
                          class="ml-0 filterBtn"
                        >
                          <v-img
                            :src="
                              require('../../assets/images/filter-icon.svg')
                            "
                            :class="{
                              fillterIconSmall: $vuetify.breakpoint.smAndDown,
                            }"
                          />
                          Filters
                        </v-btn>
                      </template>
                      <template v-slot:default="filterDialog">
                        <v-card class="rounded-xl">
                          <v-card-title>
                            <span class="text-h5">Sort & Filter</span>
                          </v-card-title>

                          <v-card-text>
                            <v-tabs vertical class="vertical-tab-Two mb-15">
                              <v-tab class=""> Type </v-tab>

                              <v-tab class=""> Terminal </v-tab>

                              <v-tab-item>
                                <v-card flat class="mx-auto" tile>
                                  <v-list>
                                    <v-list-item-group color="primary">
                                      <v-list-item>
                                        <v-list-item-content>
                                          <v-radio-group
                                            column
                                            v-model="selectedFlightType"
                                            @change="onApplyFilter"
                                          >
                                            <v-radio
                                              v-for="(
                                                flightType, i
                                              ) in flightsTypes"
                                              v-bind:label="flightType.text"
                                              v-bind:value="flightType.value"
                                              v-bind:key="i"
                                            ></v-radio>
                                          </v-radio-group>
                                        </v-list-item-content>
                                      </v-list-item>
                                    </v-list-item-group>
                                  </v-list>
                                </v-card>
                              </v-tab-item>

                              <v-tab-item>
                                <v-list-item-content>
                                  <v-radio-group
                                    column
                                    v-model="selectedTerminal"
                                    @change="onApplyFilter"
                                  >
                                    <v-radio
                                      v-for="(terminal, i) in terminals"
                                      v-bind:label="terminal.text"
                                      v-bind:value="terminal.value"
                                      v-bind:key="i"
                                    />
                                  </v-radio-group>
                                </v-list-item-content>
                              </v-tab-item>
                            </v-tabs>
                          </v-card-text>
                          <v-card-actions class="justify-end">
                            <v-btn text @click="onResetFilter()">
                              Reset Filters >
                            </v-btn>
                            <v-btn
                              rounded
                              dark
                              large
                              class="gradient-button pl-10 pr-10"
                              @click="onApplyFilter()"
                            >
                              Apply
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </template>
                    </v-dialog>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="2" class="hidden-sm-and-down">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-btn
                      rounded
                      dark
                      large
                      class="gradient-button"
                      @click="onResetFilter"
                    >
                      See All Flights
                    </v-btn>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-card>
          <v-row class="mb-10">
            <v-col>
              <v-card flat>
                <v-card-actions>
                  <span> Last updated: {{ current.fullDate }} IST </span>
                  <v-spacer></v-spacer>
                  <v-btn
                    depressed
                    rounded
                    dark
                    large
                    :disabled="isRefreshing"
                    class="gradient-button pl-10 pr-10"
                    @click="onRefresh()"
                  >
                    <v-icon left>mdi-refresh</v-icon>
                    Refresh
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-data-table
            :page.sync="pagination.page"
            :items-per-page="pagination.limit"
            :loading="loader"
            @click:row="onRowClick"
            :headers="departureHeader"
            :items="flights"
            class="mytable hidden-sm-and-down"
            hide-default-header
          >
            <template v-slot:header="{ props: { headers } }">
              <thead class="">
                <tr>
                  <th v-for="h in headers" :class="h.class">
                    <span>{{ h.text }}</span>
                  </th>
                </tr>
              </thead>
            </template>
            <template v-slot:[`item.airlineName`]="{ item }"
              ><span class="small-text-table" style="display: block">{{
                item.airlineName
              }}</span>
              <span>{{ item.flightName }}</span></template
            >
            <template v-slot:[`item.img`]="{ item }">
              <v-card flat color="transparent" class="pt-6 pb-6">
                <v-card-title class="pa-0 ml-6">
                  <v-avatar
                    tile
                    :size="$vuetify.breakpoint.smAndDown ? '40' : '56'"
                  >
                    <img :src="item.img" class="mt-1" />
                  </v-avatar>
                </v-card-title>
              </v-card>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <v-alert
                class="rounded-xl text-center status-alert"
                text
                :color="renderStatus(item.status)"
              >
                {{ item.status }}
              </v-alert>
            </template>
            <template v-slot:[`item.scheduled`]="{ item }">
              <td class="">
                {{ item.scheduled }}
              </td>
            </template>
            <template v-slot:[`item.terminal`]="{ item }">
              <td class="">
                {{ item.terminal }}
              </td>
            </template>
            <template v-slot:[`item.counters`]="{ item }">
              <td class="">
                <div
                  v-for="(counter, i) in renderCounters(item.counters)"
                  :key="i"
                >
                  <span>{{ counter }}</span>
                </div>
              </td>
            </template>
            <template v-slot:[`item.gates`]="{ item }">
              <td class="">
                {{ item.gates }}
              </td>
            </template>
          </v-data-table>

          <v-data-table
            :loading="loader"
            @click:row="onRowClick"
            :headers="departureHeader"
            :items="flights"
            class="mobileTable hidden-md-and-up"
            hide-default-header
            hide-default-footer
            disable-pagination
          >
            <template v-slot:item="{ item }">
              <v-card class="mobileCard" @click="onRowClick(item)">
                <v-list>
                  <v-list-item>
                    <v-list-item-avatar
                      :size="$vuetify.breakpoint.smAndDown ? '40' : '56'"
                    >
                      <img :src="item.img" style="height: auto" />
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-subtitle>{{
                        item.airlineName
                      }}</v-list-item-subtitle>
                      <v-list-item-title>{{
                        item.flightName
                      }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-alert
                        class="rounded-xl text-center"
                        text
                        :color="renderStatus(item.status)"
                      >
                        {{ item.status }}
                      </v-alert>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
                <v-list>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle>{{
                        item.originmap
                      }}</v-list-item-subtitle>
                      <v-list-item-title>{{ item.origin }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-avatar size="25">
                      <v-img :src="require('../../assets/images/plain.svg')" />
                    </v-list-item-avatar>
                    <v-list-item-content class="text-end">
                      <v-list-item-subtitle>{{
                        item.destinationmap
                      }}</v-list-item-subtitle>
                      <v-list-item-title>{{
                        item.destination
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-card-actions>
                  <span style="margin-right: 5px"
                    >Scheduled
                    <label style="font-weight: 700">{{ item.scheduled }}</label>
                  </span>
                  |
                  <span style="margin-left: 5px"
                    >Estimated
                    <label style="font-weight: 700">{{
                      item.estimated
                    }}</label></span
                  >
                </v-card-actions>
              </v-card>
            </template>
          </v-data-table>
        </v-container>
      </v-tab-item>
    </v-tabs>
    <!-- Tabs Section -->
  </v-card>
</template>
<script>
import _ from "lodash";
import api from "../../api";
import config from "../../config";

export default {
  name: "Template-2",
  props: ["data"],
  data() {
    return {
      url: config.airport.url,
      loader: false,
      tab: "arrivals",
      search: "",
      flightsTypes: [
        { text: "All Flights", value: "" },
        { text: "International", value: "international" },
        { text: "Domestic", value: "domestic" },
      ],
      selectedFlightType: "",
      allFlights: [],
      flights: [],
      terminals: [],
      selectedTerminal: "",
      filterDialog: false,
      isRefreshing: false,
      pagination: {
        page: 0,
        limit: 15,
      },
      arrivalHeader: [
        {
          class: "header-airline",
          text: "Airline",
          align: "center",
          filterable: false,
          value: "img",
          sortBy: "flight",
          width: "6%",
        },
        { text: "Flight Name", value: "airlineName" },
        { text: "Origin", value: "originmap" },
        { text: "Scheduled", value: "scheduled" },
        { text: "Estimated", value: "estimated" },
        { text: "Status", value: "status" },
        { text: "Terminal", value: "terminal" },
        { text: "Baggage", value: "carousel" },
      ],
      departureHeader: [
        {
          class: "header-airline",
          text: "Airline",
          align: "start",
          filterable: false,
          value: "img",
          sortBy: "flight",
          width: "6%",
        },

        { text: "Flight", value: "airlineName" },
        { text: "Destination", value: "destinationmap" },
        { text: "Scheduled", value: "scheduled" },
        { text: "Estimated", value: "estimated" },
        { text: "Status", value: "status" },
        { text: "Terminal", value: "terminal" },
        { text: "Check-in", value: "counters" },
        { text: "Gate", value: "gates" },
      ],
      defaultFilter: {
        search: null,
        tab: null,
      },
    };
  },
  computed: {
    current: {
      get() {
        return this.$store.getters.current;
      },
    },
  },
  methods: {
    async onResetFilter() {
      this.selectedFlightType = "";
      this.selectedTerminal = "";
      this.search = null;
      this.filterDialog = false;
      await this.onLoadFlights();
    },
    onApplyFilter() {
      try {
        let data = this.allFlights;
        if (
          !this.search &&
          !this.selectedFlightType &&
          !this.selectedTerminal
        ) {
          this.flights = this.allFlights;
          this.filterDialog = false;
          return;
        }

        if (this.selectedTerminal) {
          data = data.filter((item) => item.terminal === this.selectedTerminal);
        }

        if (this.selectedFlightType) {
          let tabInitial =
            this.tab === "arrivals" ? "A" : this.tab === "departure" ? "D" : "";
          let flightTypeInitial =
            this.selectedFlightType === "domestic"
              ? "D"
              : this.selectedFlightType === "international"
              ? "I"
              : "";
          let filterType = `${flightTypeInitial}${tabInitial}`;
          data = data.filter((item) => item.nature === filterType);
        }

        if (this.search) {
          data =
            this.tab === "arrivals"
              ? data.filter(
                  (item) =>
                    String(item.originmap)
                      .toLowerCase()
                      .includes(this.search.toLowerCase()) ||
                    String(item.flightName)
                      .toLowerCase()
                      .includes(this.search.toLowerCase())
                )
              : data.filter(
                  (item) =>
                    String(item.destinationmap)
                      .toLowerCase()
                      .includes(this.search.toLowerCase()) ||
                    String(item.flightName)
                      .toLowerCase()
                      .includes(this.search.toLowerCase())
                );
        }

        this.filterDialog = false;

        this.flights = data;
      } catch (error) {}
    },
    async onRefresh() {
      await this.onLoadFlights();
    },
    onRowClick(row) {
      this.$store.dispatch("onUpdateFlight", row);
      this.$router.push(`/flight/${this.tab}/${row.id}`);
    },
    renderStatus(status) {
      if (status == "Delayed") return "red";
      else if (status == "Gate Closed") return "red";
      else if (status == "Final Call") return "red";
      else if (status == "Departed") return "red";
      else if (status == "Check-in Open") return "blue";
      else if (status == "Boarding") return "blue";
      else if (status == "Security Check") return "blue";
      else if (status == "Arrived") return "success";
      else if (status == "On Time") return "success";
      else return "success";
    },
    renderCounters(data) {
      let counters = data.split(",");
      let chunks = [];
      let result = [];
      counters.pop();
      if (counters.length) {
        chunks = _.chunk(counters, 5);
      }

      if (chunks.length) {
        for (const chunk of chunks) {
          result.push(chunk.join(","));
        }
      }

      return result;
    },
    async onLoadFlights() {
      try {
        this.loader = true;
        this.isRefreshing = true;
        this.$store.dispatch("onSetCurrentDate", { isFulltime: true });
        let startTime = new Date(
          new Date().getTime() - 30 * 60 * 1000
        ).getTime();
        let endTime = new Date().getTime() + 24 * 60 * 60 * 1000;
        const { data } = await api.insuide.get(
          `flightsroute/getflightfeed?appname=maa&starttime=${startTime}&endtime=${endTime}`
        );
        if (data?.success) {
          let current = new Date();
          let hour = current.getHours();
          let flightData = [];
          data.flights.forEach((flight) => {
            let scheduledDate = new Date(flight.scheduledArrivalDate);
            let estimatedDate = new Date(flight.estimatedArrivalDate);
            let scheduleMinute =
              scheduledDate.getMinutes() < 10
                ? "0" + scheduledDate.getMinutes()
                : scheduledDate.getMinutes();
            let estimatedMinute =
              estimatedDate.getMinutes() < 10
                ? "0" + estimatedDate.getMinutes()
                : estimatedDate.getMinutes();
            if (
              scheduledDate.getDate() >= current.getDate() &&
              scheduledDate.getHours() >= hour
            ) {
              flightData.push({
                ...flight,
                img: `${config.poi.url}flightlogo/getimage/${flight.airlineCode}.png`,
                scheduled: `${scheduledDate.getHours()}:${scheduleMinute}`,
                estimated: `${estimatedDate.getHours()}:${estimatedMinute}`,
              });
            }
          });
          flightData =
            this.tab === "arrivals"
              ? flightData.filter(
                  (flight) => flight.nature === "DA" || flight.nature === "IA"
                )
              : flightData.filter(
                  (flight) => flight.nature === "DD" || flight.nature === "ID"
                );
          this.terminals = Array.from(
            new Set(
              flightData
                .map((flight) => flight.terminal)
                .sort((a, b) => parseInt(a) - parseInt(b))
            )
          ).map((terminal) => {
            return { text: `Terminal-${terminal}`, value: terminal };
          });
          this.terminals.unshift({ text: "All Terminals", value: "" });
          this.allFlights = this.flights = flightData;
          if (this.defaultFilter.search || this.defaultFilter.tab) {
            this.onApplyFilter();
            this.defaultFilter = {
              search: null,
              tab: null,
            };
          }
          this.loader = false;
          this.isRefreshing = false;
        }
      } catch (error) {
        this.isRefreshing = false;
      }
    },
    async onSelectTab() {
      await this.onLoadFlights();
    },
    onLoadDefaultFilters() {
      let defaultFilter = this.$store.getters.search;
      if (defaultFilter) {
        this.defaultFilter = {
          search: defaultFilter.flight,
          tab: defaultFilter.type,
        };

        if (defaultFilter.flight) this.search = defaultFilter.flight;
        if (defaultFilter.type)
          this.tab = String(defaultFilter.type).toLowerCase();
        this.$store.dispatch("onUpdateFlightSearch", {
          flight: "",
          type: "",
        });
      }
    },
  },
  async mounted() {
    this.onLoadDefaultFilters();
    await this.onLoadFlights();
  },
};
</script>
<style type="text/css">
.theme--light.v-tabs .v-tab--active:hover::before,
.theme--light.v-tabs .v-tab--active::before {
  opacity: 0;
}
.mobileCard {
  padding: 10px 12px;
  margin: 10px 5px;
  border: 1px solid #f3f4f6;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
  border-radius: 12px !important;
}
.mobileCard .v-card__actions {
  font-size: 13px;
  padding: 0;
}
.mobileCard .v-alert {
  font-size: 14px;
}
.mobileTable .v-list-item__title {
  font-size: 14px !important;
  font-weight: 700 !important;
}
.v-input__slot {
  box-shadow: none !important;
}
.v-menu__content .v-list {
  padding: 0 5px !important;
}
.mobileTable .v-data-table__wrapper table {
  border-collapse: separate;
  border-spacing: 0 5px !important;
}

.mobileTable td {
  padding: 10px 12px !important ;
  border: 1px solid #f3f4f6;
  /* shadow-card */

  box-shadow: 0px 20px 25px -5px rgba(16, 24, 40, 0.04),
    0px 8px 10px -6px rgba(16, 24, 40, 0.04);
  border-radius: 12px;
}

.mobileTable td .theme--light.v-list {
  background: transparent;
}
.v-alert {
  margin-bottom: 0;
  padding: 6px 18px;
}

.v-list-item {
  padding: 0;
}

.v-btn.filterBtn {
  min-width: 65px !important;
  margin-bottom: 10px !important;
}

.small-text-table {
  font-size: 16px;
  font-weight: 500;
}

.v-list-item__avatar {
  align-self: flex-start !important;
  margin-top: 12px !important;
}

.v-list-item__content {
  padding: 1px 0 1px 0 !important;
}

.searchBox {
  margin: 0 auto;
  height: 93px;
  width: 100%;
}

.searchBox .v-list-item {
  padding: 0 !important;
}

.searchBox .v-text-field .v-label {
  width: 100%;
}
.fillterIconSmall .v-image__image--cover {
  background-size: inherit;
  flex: none !important;
}

.mytabs .v-item-group {
  margin-bottom: 30px;
}

.v-data-table-header th {
  white-space: nowrap;
}

.modifyAlert {
  background: #ff5152;
  padding: 13px 20px;
  border-radius: 10px;
  color: #fff;
}

.v-list-item__content .v-input--radio-group--column {
  margin-left: 20px;
}

@media (min-width: 960px) {
  .status-alert {
    margin: 0 auto; /* center it horizontally */
    width: 135px !important; /* let it flow inside the cell */
  }
}

/*.v-data-table > .v-data-table__wrapper > table > tbody > tr > td:nth-child(9) {
  padding: 0 5px;
}*/

/* .mytable .v-data-table__wrapper table tbody tr:hover {} */

.mytable > table > thead > tr > th {
  text-align: center;
}
</style>
